import { motion } from "framer-motion";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaTimes,
} from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { LuMailbox } from "react-icons/lu";

import "../styles/NexaAccelerator/ContactSection.css";

const socialLinks = [
  {
    icon: FaTiktok,
    url: "https://www.tiktok.com/@nexagrowth.africa?_t=ZM-8wzOQ1dRBbU&_r=1",
  },
  {
    icon: FaInstagram,
    url: "https://www.instagram.com/nexagrowthafrica?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  },
  {
    icon: FaFacebookF,
    url: "https://web.facebook.com/profile.php?id=61577001723719",
  },
  {
    icon: FaLinkedinIn,
    url: "https://www.linkedin.com/company/nexagrowth-africa/",
  },
];

export default function ContactSection() {
  return (
    <section className="contact-section">
      <motion.div
        className="contact-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="left">
          <motion.h2
            className="section-title"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Contact <span className="highlight">Us</span>
          </motion.h2>
          <motion.h2
            className="contact-heading"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Start Your Journey With Us
          </motion.h2>
          <div className="social-icons">
            {socialLinks.map(({ icon: Icon, url }, i) => (
              <motion.a
                key={i}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                whileHover={{ scale: 1.2 }}
              >
                <Icon />
              </motion.a>
            ))}
          </div>{" "}
        </div>
        <motion.div
          className="right"
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <div className="contact-info">
            <FaEnvelope className="icon" />
            <span>info@nexagrowthafrica.com</span>
          </div>
          <div className="contact-info">
            <FaPhoneAlt className="icon" />
            <span>+233 549 213 246</span>
          </div>
          <div className="contact-info">
            <FaMapMarkerAlt className="icon" />
            <span>16 Coquette Street</span>
          </div>
          <div className="contact-info">
            <LuMailbox className="icon" />
            <span>
              Madina New Road
              <br /> Accra, Ghana
            </span>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
